import {
    Edge,
    HandsEdges,
    RenderJoint,
    unifiedHandDefaultDrawEdges,
    UnifiedHandKeypoints,
    SideOfBody,
} from '@exerai/vision-engine-web';
import { initKeypoints } from './keypoints';

export const getDisplayedHandKeypoints = (detectedKeypoints: UnifiedHandKeypoints): UnifiedHandKeypoints => {
    const renderKeypoints: UnifiedHandKeypoints = {} as UnifiedHandKeypoints;
    Object.entries(detectedKeypoints).forEach((entry) => {
        const [key, joint] = entry as [string, RenderJoint];
        const renderJoint: RenderJoint = {
            dsId: initKeypoints[key].dsId,
            name: initKeypoints[key].name,
            hexColor: joint.hexColor,
            hidden: initKeypoints[key].hidden,
            coordinates: joint.coordinates,
            confidence: joint.confidence,
        };
        renderKeypoints[key] = renderJoint;
    });
    return renderKeypoints;
};

export const getDisplayedHandEdges = (keypoints: UnifiedHandKeypoints): HandsEdges => {
    const renderEdges = {} as HandsEdges;
    if (!keypoints) {
        return renderEdges;
    }
    Object.entries(unifiedHandDefaultDrawEdges).forEach((entry) => {
        const [key, edge] = entry;
        let hidden = edge.hidden;
        const con1 = keypoints[edge.jointIds[0]].confidence || 0;
        const con2 = keypoints[edge.jointIds[1]].confidence || 0;
        if (con1 < 0.5 && con2 < 0.5) {
            hidden = true;
        }
        const renderEdge: Edge = {
            dsId: edge.dsId,
            name: edge.name,
            joints: [keypoints[edge.jointIds[0]], keypoints[edge.jointIds[1]]],
            hexColor:
                keypoints[edge.jointIds[0]].side == SideOfBody.Left
                    ? '#ff00ff'
                    : keypoints[edge.jointIds[0]].side == SideOfBody.Right
                    ? '#00ffff'
                    : edge.hexColor,
            hidden,
        };
        renderEdges[key] = renderEdge;
    });
    return renderEdges;
};
